import React, { FunctionComponent } from "react";
import { FormControl, FormHelperText, Grid, NativeSelect } from "@material-ui/core";
import { useTranslation } from "react-i18next";

type FieldCashbackFromHallProps = {
    error: boolean;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    value: number;
    formHelperText: string;
};

function cmp(prev: FieldCashbackFromHallProps, cur: FieldCashbackFromHallProps): boolean {
    return prev.error === cur.error && prev.formHelperText === cur.formHelperText && prev.value === cur.value;
}

const FieldCashbackFromHall: FunctionComponent<FieldCashbackFromHallProps> = React.memo(({ error, onChange, value, formHelperText }) => {
    const [t] = useTranslation();
    return <Grid item xs={12} sm={3}>
        <FormControl error={error} fullWidth size="small">
            <NativeSelect onChange={onChange} value={value}>
                <option value={0}>{t("ru.halls.selectors.no")}</option>
                <option value={1}>{t("ru.halls.selectors.yes")}</option>
            </NativeSelect>
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
}, cmp);

export default FieldCashbackFromHall;
